import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Award, Loader2, XCircle } from "lucide-react";
import { api } from "../lib/api";

export default function VerifyCertificatePage() {
  const { id } = useParams();
  const [c, setC] = useState(null);
  useEffect(() => { api.get(`/public/certificates/${id}`).then((r) => setC(r.data)).catch(() => setC(false)); }, [id]);
  return (
    <div className="min-h-screen bg-[#f7f3ec] flex items-center justify-center p-6" data-testid="verify-cert-page">
      <div className="max-w-md w-full bg-white rounded-3xl p-8 text-center space-y-3 shadow-sm">
        <img src="/brand/logo-full.png" alt="Locked In Forever" className="h-20 mx-auto" />
        {c === null ? <Loader2 className="w-6 h-6 animate-spin mx-auto" /> : c === false ? <><XCircle className="w-10 h-10 mx-auto text-red-500" /><p className="font-serif text-2xl" data-testid="verify-invalid">No certificate found with number {id}</p></>
          : <><Award className="w-10 h-10 mx-auto text-[var(--gold)]" /><p className="text-[11px] uppercase tracking-[0.22em] text-[var(--gold)]">Verified certificate</p>
            <p className="font-serif text-3xl" data-testid="verify-name">{c.name}</p>
            <p className="text-sm text-[#5c544b]">earned the Locked In Forever Training Mastery certificate on {new Date(c.issued_at).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })}, passing {c.courses} course{c.courses === 1 ? "" : "s"} and {c.walkthroughs} walkthrough{c.walkthroughs === 1 ? "" : "s"} (average {c.avg_score}%).</p>
            <p className="text-xs text-[#8a8178]">No. {c.cert_id}</p></>}
        <p className="text-[11px] text-[#8a8178] pt-2">Powered by Locked In Forever™</p>
      </div>
    </div>
  );
}
